import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { Colors } from '../../../../util/util'

export const styles = {
  mainView: {
    minHeight: 65,
  } as BoxProps,
  textAndIcon: {
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
  iconContainer: {
    paddingLeft: 12,
  } as BoxProps,
  titleText: {
    fontSize: 12,
    fontFamily: 'jiotype-medium',
    lineHeight: 18,
    color: '#202F4D8A' as ColorOptions,
  } as TextNewProps,
  titleAligner: {
    justify: 'center',
  } as BoxProps,
  downloadSample: (isValueAvailable: boolean) =>
    ({
      borderRadius: 4,
      flex: 1,
      justify: 'center',
      borderWidth: 1,
      borderColor: isValueAvailable ? ('#B9CBF0' as ColorOptions) : ('LIGHT_GREY_INTRO' as ColorOptions),
      //ml: 20,
    } as BoxProps),
  superContainer: {
    flexDirection: 'row',
    width: '100%',
  } as BoxProps,
  downloadContainer: {
    alignSelf: 'flex-end',
    bg: 'RED',
  } as BoxProps,
  downloadStyleText: (isValueAvailable: boolean) =>
    ({
      fontSize: 12,
      textAlign: 'center',
      fontFamily: 'jiotype-medium',
      lineHeight: 18,
      color: isValueAvailable ? Colors.REPORT_PRIMARY : 'LIGHT_GREY_INTRO',
    } as TextNewProps),

  configurationContainer: {
    flexDirection: 'column',
    width: '100%',
    borderColor: '#B9CBF0' as ColorOptions,
    borderWidth: 1,
    padding: 15,
    borderRadius: 8,
  } as BoxProps,
}
